<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form action="/api/auth/local" method="POST">
                <card type="login">
                  <!--h3 slot="header" class="header text-center login-title">Autoflota</h3-->
                  <img class="login-logo text-center" src2="/static/img/new-logo.png" src="/static/img/Flota_RGB_pos.jpg" />
                  <p class="text-warning text-center login-text-custom" v-if="!errorMsg">{{infoMsg}}</p>
                  <p class="text-danger text-center" v-if="errorMsg">{{errorMsg}}</p>

                    <fg-input v-model="form.username" name="username" addon-left-icon="nc-icon nc-single-02"
                              :placeholder='$t( "login.username")'></fg-input>

                    <fg-input v-model="form.password" name="password" addon-left-icon="nc-icon nc-key-25" :placeholder='$t( "login.password")'
                              type="password"></fg-input>
<!--
                  <p-button type="default" round block class="mb-3" @click="login">
                    <i class="fa fa-heart"></i> Login with google
                  </p-button>
-->
                  <p-button native-type="submit" type="warning" block class="mb-3 login-signin">{{ $t( "login.signIn") }}</p-button>

                  <a class="text-center"
                    v-if= googleAuthEnabled
                    slot="footer"
                    aria-label="sidebar mini logo"
                    href="api/auth/google">
                      <div class="logo-img">
                          <img src="img/icons/google.png" alt="">
                      </div>
                  </a>
                </card>
              </form>
            </div>
          </div>
        </div>
        <div class="full-page-background" style="background-image: url(static/img/background/flota-login-bg_2.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>

  import Vue from "vue";
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'


  export default {
    components: {
      Card,
      AppNavbar,
      //[Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    data() {
      return {
        errorMsg: '',
        infoMsg: this.$t('login.title'),
        form: {
          username: '',
          password: ''
        },
        googleAuthEnabled: false
      }
    },
    computed: {},
    mounted () {
      let error = this.$route.query.error;
      let errorMsg = this.$t('login.notAllowed');
      if (error && error === 'notAllowed') this.errorMsg = errorMsg;

    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      async login() {
        // handle login here
        console.log('login!');
        let response;
        try {
          response = await Vue.axios.post("/auth/local", this.form);
        }
        catch(err) {
          console.log('huh? ', err);
        }
        console.log('herrooo', response);
        console.log('response.data', response.data);
        this.$router.push(response.data);

      },
      logina() {
        // handle login here
        console.log('login');
        this.$gAuth
          .getAuthCode()
          .then(authCode => {
            //on success
            console.log("authCode", authCode);
            return this.$http.post(`auth/google/callback`, { code: authCode, redirect_uri: 'postmessage' })
          })

          .then(resp => {
            console.log('resp from callback', resp);
          })
          .catch(error => {
            console.log('catch error', error)
            //on fail do something
          });

      }

    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style>
  /* body {
    overflow: hidden;
  } */
  .login-title {
    margin-bottom: 0px;
  }

  .login-logo {
    height: 120px;
     display:block;
    margin:auto;
  }

  .login-text-custom {
    font-size: 1.2em;
    font-weight: bold;
  }

  .section-image:after {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .input-group-text {
    color: forestgreen;
  }

  .card-login .input-group-text {
      padding: 10px 10px 10px 10px !important;
  }

  .login-signin {
    font-weight: bold;
    font-size: 1em;
  }

  .login-page .full-page-background {
    background-position: unset !important;
  }
</style>
